import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Services() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const pillars = [
    { num: '01', titleKey: 's1_title', descKey: 's1_desc', accentColor: '#C4553A' },
    { num: '02', titleKey: 's2_title', descKey: 's2_desc', accentColor: '#D4A853' },
    { num: '03', titleKey: 's3_title', descKey: 's3_desc', accentColor: '#1A3A5C' },
  ];

  return (
    <section id="servicios" className="bg-[#F7F5F0] py-28 md:py-36">
      <div ref={ref} className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div
          className={`mb-6 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
        >
          <span className="font-['JetBrains_Mono'] text-[10px] tracking-[0.22em] uppercase text-[#C4553A] block mb-5">
            {t('services_label')}
          </span>
          <h2 className="font-['Instrument_Serif'] text-4xl md:text-5xl text-[#0B0F1A] leading-tight mb-5">
            {t('services_title')}
          </h2>
          <p className="font-['DM_Sans'] text-[#6B7280] text-base leading-relaxed max-w-lg">
            {t('services_desc')}
          </p>
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-[#E8E4DC] my-12" />

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {pillars.map((p, i) => (
            <div
              key={p.num}
              className={`bg-white border border-[#E8E4DC] rounded-xl overflow-hidden flex flex-col transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{
                transitionDelay: `${i * 120}ms`,
                boxShadow: '0 2px 20px rgba(11,15,26,0.05)',
              }}
            >
              <div className="h-[3px] w-full" style={{ backgroundColor: p.accentColor }} />
              <div className="p-8 md:p-9 flex flex-col gap-6 flex-1">
                <span className="font-['JetBrains_Mono'] text-xs text-[#6B7280]/70 tracking-widest">
                  {p.num}
                </span>
                <div className="flex flex-col gap-4">
                  <h3 className="font-['Instrument_Serif'] text-2xl md:text-3xl text-[#0B0F1A]">
                    {t(p.titleKey)}
                  </h3>
                  <p className="font-['DM_Sans'] text-[#6B7280] text-sm leading-relaxed">
                    {t(p.descKey)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
